import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authAPI, setStoredToken } from '../utils/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);

      if (!match) {
        navigate('/', { replace: true });
        return;
      }

      const sessionId = match[1];

      try {
        const userData = await authAPI.googleSession(sessionId);
        if (userData?.token) setStoredToken(userData.token);
        setUser(userData);
        window.history.replaceState(null, '', '/home');
        navigate('/home', { replace: true });
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/', { replace: true });
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="w-full max-w-md mx-auto min-h-screen bg-[#F7F9FB] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-2 border-slate-900 border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-sm text-slate-500">Signing in with Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
